import Icon from "@/components/icons/Icon.jsx";
import "@/components/menu-icons.css";

/**
 * Icon + label for menus and nav items.
 * @param {{
 *   icon?: string|null,
 *   children: import("react").ReactNode,
 *   className?: string,
 *   active?: boolean,
 *   danger?: boolean,
 *   iconColor?: string,
 *   badge?: string|number|null
 * }} props
 */
export default function MenuItemLabel({
    icon,
    children,
    className = "",
    active = false,
    danger = false,
    iconColor,
    badge = null
}) {
    const showBadge = badge != null && badge !== "" && Number(badge) !== 0;
    return (
        <span className={`menu-item-label${className ? ` ${className}` : ""}`}>
            {icon ? (
                <span className="menu-item-label__icon-wrap">
                    <Icon
                        name={icon}
                        className="menu-item-label__icon"
                        color={iconColor}
                        active={active}
                        danger={danger}
                    />
                    {showBadge ? (
                        <span className="menu-item-label__badge" aria-hidden="true">
                            {badge}
                        </span>
                    ) : null}
                </span>
            ) : null}
            <span className="menu-item-label__text">{children}</span>
        </span>
    );
}
